<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-people"></i>
                            <span>{{$t('trajectories.title')}}</span>
                        </h2>
                        <div @click.prevent="showCreateTrajectoryModal" class="panel_header__action">
                            <i class="panel_header__action__icon icons icon-plus"></i>
                            <a class="button--link hidden-xs">{{$t('trajectories.add_new')}}</a>
                        </div>
                    </div>
                    <div class="panel__body">
                        <trajectories-table />
                    </div>
                </div>
            </div>
        </div>
        <trajectory-create-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import TrajectoriesTable from '@/components/tables/trajectories/TrajectoriesTable';
    import TrajectoryCreateModal from '@/components/modals/trajectories/TrajectoryCreateModal';

    @Component({
        components: {
            TrajectoriesTable,
        }
    })
    export default class Trajectories extends Vue {
        name = 'trajectories';

        showCreateTrajectoryModal() {
            this.$modal.show('trajectory-create-modal');
        }
    }

    Vue.component('trajectories', Trajectories);
</script>



// WEBPACK FOOTER //
// src/pages/Trajectories.vue